import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trans, useTranslation } from 'react-i18next';
import { useDeleteRequest } from '@/shared/hooks/requests.js';
import { PROJECT } from '@/shared/utils/urls.js';
import { toast } from 'sonner';

export function DeleteProjectModal({ open, onOpenChange, project, setData }) {
  const { t } = useTranslation(['mainPage', 'common']);
  const deleteProject = useDeleteRequest({ url: PROJECT });

  const handleDelete = async () => {
    const { success } = await deleteProject.request({
      params: { project_id: project.id },
    });
    if (success) {
      toast.success(t('projectModals.delete.success'));
      onOpenChange(false);
      setData();
    }
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-foreground">
            {t('projectModals.delete.title')}
          </DialogTitle>
          <DialogDescription className="text-base text-muted-foreground pt-2">
            <Trans
              t={t}
              i18nKey="projectModals.delete.confirm"
              values={{ name: project?.name }}
              components={{
                bold: <span className="font-semibold text-foreground" />,
              }}
            />
            <br />
            <span className="text-destructive font-medium">
              {t('projectModals.delete.irreversible')}
            </span>
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-end gap-3 pt-4">
          <Button
            variant="ghost"
            onClick={handleClose}
            className="h-11 px-6"
          >
            {t('common:cancel')}
          </Button>
          <Button
            onClick={handleDelete}
            disabled={deleteProject.loading}
            className="h-11 px-6 text-white font-medium bg-red-600 hover:bg-red-700"
          >
            {deleteProject.loading
              ? t('projectModals.delete.deleting')
              : t('common:delete')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
